import React from "react";
import iconImg from "../assets/images/icon.png";

export default function NewPage1() {
  return (
    <div className="card Upgrade">
      <div className=" p-4 m-3 row text-black">
        <div className="d-flex justify-content-between">
          <span className=" h4">About</span>
        </div>
        <div className="col-xl-12 mt-3">
          <div className="d-flex">
            <img src={iconImg} alt="logo" className="icon-img" width="50" height="50" />
            <div className="d-flex flex-column mx-3">
              <span className="m-0 font-20  h1">Find Token</span>
              <span>$FIND</span>
              <span className="mt-3">1 FIND = 68.48 USD</span>
            </div>
          </div>
        </div>
        <div className="col-xl-12 text-start mt-4">
          Find Token is a pioneering project on the Ethereum blockchain, combining the reliability of ERC-20 standards with innovative features. Our suite includes a Reward dashboard, an OTC platform for ERC20 token exchanges, a token tracker
          dashboard, staking with NFT minting, and powerful trading bots. We prioritize user safety, ensuring a secure environment for token exchanges, making us an attractive choice for investors seeking reliability in decentralized finance.
        </div>
      </div>
    </div>
  );
}
